module.exports = __webpack_public_path__ + "static/media/favicon.5d4e80c9.ico";